<template>
  <div class="stage">
    <h2 class="stage__title">{{ strings[currentStep].subtitle }}</h2>
    <StageOne v-if="currentStep === 0" />
    <StageTwo v-if="currentStep === 1" />
    <StageThree v-if="currentStep === 2" />
    <StageFour v-if="currentStep === 3" />
    <StageFive v-if="currentStep === 4" />
    <StageSix v-if="currentStep === 5" />
    <StageSeven v-if="currentStep === 6" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import StageOne from '../stages/StageOne.vue'
import StageTwo from '../stages/StageTwo.vue'
import StageThree from '../stages/StageThree.vue'
import StageFour from '../stages/StageFour.vue'
import StageFive from '../stages/StageFive.vue'
import StageSix from '../stages/StageSix.vue'
import StageSeven from '../stages/StageSeven.vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StagePage',
  components: {
    StageSeven,
    StageSix,
    StageFive,
    StageOne,
    StageTwo,
    StageThree,
    StageFour,
  },
  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      strings: [
        {
          title: __('Stage 1:', 'smdt'),
          subtitle: __('Start address', 'smdt'),
        },
        {
          title: __('Stage 2:', 'smdt'),
          subtitle: __('Destination address', 'smdt'),
        },
        {
          title: __('Stage 3:', 'smdt'),
          subtitle: __('The move', 'smdt'),
        },
        {
          title: __('Stage 4:', 'smdt'),
          subtitle: __('The inventory', 'smdt'),
        },
        {
          title: __('Stage 5:', 'smdt'),
          subtitle: __('Choice of prestation', 'smdt'),
        },
        {
          title: __('Stage 6:', 'smdt'),
          subtitle: __('Your contact details', 'smdt'),
        },
        {
          title: __('Stage 7:', 'smdt'),
          subtitle: __('Summary', 'smdt'),
        },
      ],
    }
  },
  computed: {
    ...mapState(useStagesStore, ['currentStage', 'apiData', 'currentStep']),
  },
  methods: {
    ...mapActions(useStagesStore, []),
  },
}
</script>

<style scoped lang="scss">
.stage {
  &__title {
    display: block;
    margin: 0 0 50px;
    font-weight: 700;
    font-size: 20px;
    color: var(--vn-secondary-color);
  }
}
</style>
